"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconAlertSuccess = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var IconAlertSuccess = function IconAlertSuccess(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 0c6.627 0 12 5.373 12 12 0 6.628-5.373 12-12 12S0 18.628 0 12C0 5.373 5.373 0 12 0zm-1.102 16.947l7.496-7.497a1.695 1.695 0 10-2.398-2.398l-5.994 5.994a.429.429 0 01-.606 0l-2.214-2.213a1.695 1.695 0 10-2.398 2.398L8.5 16.947a1.699 1.699 0 002.398 0z"
  }));
};
exports.IconAlertSuccess = IconAlertSuccess;